// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"bdb4dabf","170":"4efb7ab3","244":"7288cfb0","664":"ef5ea8e3"}[chunkId] + ".chunk.css";
};